import { Download } from 'lucide-react'
import { Button } from '@/components/ui/button'

// Admin Panel Redesign — generalizes the two one-off CSV export functions
// that used to live inline in AdminPanel.tsx (exportUsersCSV, exportAuditCSV).
// Every section gets export for free by passing rows + column definitions.

export interface CsvColumn<T> {
  header: string
  value: (row: T) => string | number | null | undefined
}

interface ExportCsvButtonProps<T> {
  rows: T[]
  columns: CsvColumn<T>[]
  filenamePrefix: string
  label?: string
  disabled?: boolean
}

function escapeCsvCell(value: string | number | null | undefined): string {
  const str = value === null || value === undefined ? '' : String(value)
  return `"${str.replace(/"/g, '""')}"`
}

export function ExportCsvButton<T>({
  rows,
  columns,
  filenamePrefix,
  label = 'Export CSV',
  disabled,
}: ExportCsvButtonProps<T>) {
  const handleExport = () => {
    const header = columns.map((c) => escapeCsvCell(c.header)).join(',')
    const body = rows
      .map((row) => columns.map((c) => escapeCsvCell(c.value(row))).join(','))
      .join('\n')
    const blob = new Blob([header + '\n' + body], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `${filenamePrefix}_${new Date().toISOString().split('T')[0]}.csv`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }

  return (
    <Button variant="outline" onClick={handleExport} disabled={disabled || rows.length === 0} title={label}>
      <Download className="mr-2 h-4 w-4" />
      {label}
    </Button>
  )
}
